import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
  header: {
    paddingBottom: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid var(--lines-1st-pr, rgba(46, 49, 94, 0.16))',
    [theme.breakpoints.down('sm')]: {
      marginTop: '50px',
    },
  },
  headerLabel: {
    fontWeight: 800,
    fontSize: '24px',
    lineHeight: '32px',
    color: '#000000',
  },
  teamContainer: {
    maxWidth: '738px',
    margin: '20px auto',
  },
  headerContent: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  headerLeft: {
    display: 'flex',
    gap: '8px',
  },
  headerContentLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '2px',
    color: 'var(--icon-2nd-pr-text, #666)',
    fontFamily: 'Manrope',
    fontSize: '12px',
    fontStyle: 'normal',
    lineHeight: '16px',
  },
  headerText: {
    fontWeight: 400,
  },
  headerNumber: {
    fontWeight: 700,
  },
  teamContent: {
    [theme.breakpoints.down('sm')]: {
      overflowY: 'auto',
      '&::-webkit-scrollbar': {
        width: 0,
        height: 0,
      },
    },
  },
  table: {
    borderRadius: '8px',
    border: '1px solid rgba(46, 49, 94, 0.16)',
    marginTop: '20px',
    [theme.breakpoints.down('sm')]: {
      width: '738px',
    },
  },
  tableItem: {
    padding: '16px 24px',
    display: 'flex',
    alignItems: 'center',
  },
  colLeft: {
    width: '45%',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  colRight: {
    width: '55%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  buttonRole: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  },
  buttonInvite: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  avatar: {
    width: '32px',
    height: '32px',
    background: 'var(--2nd-primary, #797FED)',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#FFF',
    fontFamily: 'Manrope',
    fontSize: '16px',
    fontWeight: 800,
    lineHeight: '20px',
  },
  avatarEmail: {
    width: '32px',
    height: '32px',
    background: '#DDDEE5',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#FFF',
    fontFamily: 'Manrope',
    fontSize: '16px',
    fontWeight: 800,
    lineHeight: '20px',
  },
  name: {
    paddingBottom: '2px',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    color: '#222',
    fontFamily: 'Manrope',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '20px',
  },
  tagName: {
    borderRadius: '4px',
    border: '1px solid rgba(0, 0, 0, 0.08)',
    background: 'var(--label-selector, #0CB092)',
    padding: '1px 6px 2px 6px',
    color: '#FFF',
    fontFamily: 'Manrope',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '17px',
  },
  email: {
    color: 'var(--icon-2nd-pr-text, #666)',
    fontFamily: 'Manrope',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
  },
  owner: {
    padding: '8px 24px',
    color: 'var(--icon-3rd-pr-text, #999)',
    fontFamily: 'Manrope',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '20px',
  },
  invitePending: {
    padding: '8px 24px',
    color: 'var(--icon-3rd-pr-text, #999)',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
  },
  row: {
    borderTop: '1px solid rgba(46, 49, 94, 0.08)',
  },
  roleItem: {
    padding: '8px 16px',
    cursor: 'pointer',

    '&:hover': {
      background: 'var(--hover, rgba(86, 94, 237, 0.08))',
    },
  },
  roleLabel: {
    color: 'var(--text, #333)',
    fontFamily: 'Manrope',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '20px',
    paddingBottom: '4px',
  },
  roleContent: {
    color: '#999',
    fontFamily: 'Manrope',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '18px',
  },
  menuRoleModal: {
    '& .MuiPaper-root': {
      maxWidth: '280px',
      [theme.breakpoints.down('xs')]: {
        marginTop: '50px',
      },
    },
  },
}));
